import * as React from "react";
import ReactDOM from "react-dom";
import AppWrapper from "./AppWrapper";
import "./index.css";
// eslint-disable-next-line no-undef
const rootNode = document.getElementById("root");

ReactDOM.render(<AppWrapper />, rootNode);
